
export default [
    { 'region': 'Taiwan', 
      'brands': [ 'ACES.jpg', 'FineTek.jpg', 'HITACHI.jpg', 'Howard.jpg', 'innodisk.jpg', 'KIYO.jpg', 'LITEMAX.jpg', 'murata.jpg', 
                  'Otsuka.jpg', 'TAITRA.jpg', 'tsmc.jpg', '天明製藥.jpg', '成功案例-1.jpg', '成功案例-2.jpg', '成功案例-3.jpg', 
                  '君鴻國際酒店.jpg', '宏名實業.jpg', '阿曼開發集團.jpg', '雄獅旅遊.jpg', '資拓宏宇.jpg', '遠建不動產.jpg', '數位時代.jpg', '總建建設.jpg' ]},
    { 'region': 'USA', 
      'brands': [ 'Embassy.jpg', 'eset.jpg', 'Flow.jpg', 'MIT.jpg', 'University of Minnesota.jpg' ] } ,
    { 'region': 'Singapore', 
      'brands' : [ 'cityneon.jpg', 'Mitutoyo.jpg', 'TIVO.jpg', 'TravelCue.jpg' ] },
    { 'region': 'China', 
      'brands' : [ 'SUNNEX.jpg', '海之信.jpg' ] },
    { 'region': 'Hong Kong', 
      'brands' : [ 'AsiaOne.jpg', '和利鋼鐵.jpg', '香港警務處.jpg', '喜里建設.jpg' ] }
]